import React from 'react'
import { ButtonWrapper, Roll } from './ElementsStyles'
import { ReactComponent as UnderSVG } from '../../../../lib/assets/under.svg'
import { ReactComponent as OverSVG } from '../../../../lib/assets/over.svg'
export default function RollButtons() {
  return (
    <ButtonWrapper>
      <Roll under>
        <UnderSVG />
        <p>Roll Under</p>
      </Roll>
      <Roll>
        <OverSVG /> <p> Roll Over</p>
      </Roll>
    </ButtonWrapper>
  )
}
